import AuthenticationContext from "adal-angular";
import axios from "axios";


export const adalConfig = {
  tenant: process.env.REACT_APP_TENANT,
  clientId: process.env.REACT_APP_CLIENTID,
  endpoints: {
    api: "https://graph.microsoft.com",
  },
  navigateToLoginRequestUrl: false,
  cacheLocation: "localStorage",
};

export const authContext = new AuthenticationContext(adalConfig);
export const getToken = () => authContext.getCachedToken(adalConfig.clientId);

export const getUser = () => {
  localStorage.setItem(
    "user-profile",
    localStorage.getItem("account")
  );
};

export const getGroups = (instance) => {
  let account = localStorage.getItem("account");
  if (account) {
        var config = {
          method: "get",
          url: "https://graph.microsoft.com/v1.0/me/memberOf",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("teste")
          },
        };

        axios(config)
          .then(function (response) {
            localStorage.setItem("user-groups", JSON.stringify(response.data));
          })
          .catch(function (error) {
            console.log(error);
          });
  }
};
